import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ReadScimSettings } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { FieldQuery } from '../../types';
import { scimQueryKey } from './invalidate-scim-queries';

export type GetScimSettingsParams = {
  organizationId: string;
  fields?: FieldQuery<ReadScimSettings>;
};

export const getScimSettings = async (
  params: GetScimSettingsParams,
): Promise<ReadScimSettings> => {
  return await tinctApi.scim.getScimSettings(
    params.organizationId,
    params.fields,
  );
};

/**
 * The workspace's SCIM settings. Only asked for a workspace entitled to single sign-on (404
 * otherwise) and by its admins (403 otherwise); a refused read is not retried.
 */
export const useGetScimSettings = (
  params: GetScimSettingsParams,
  options?: Omit<UseQueryOptions<ReadScimSettings, ApiError>, 'queryKey'>,
) =>
  useQuery({
    queryKey: [...scimQueryKey(params.organizationId), 'settings', params.fields],
    queryFn: () => getScimSettings(params),
    retry: false,
    ...options,
  });
